import queryString from 'query-string';
import request, {setAppHeader} from '@apps-common/js-client/api/request';
import {
  API_BASE_URL,
  PDA_ADMIN_V0_BASE_PATH,
  PDA_ADMIN_V1_BASE_PATH,
  REPORTS_API_BASE_PATH,
} from '@account/config';

/**
 * request uses axios behind the scenes. To understand this you may look at the axios docs
 * https://axios-http.com/docs/intro
 */

request.defaults.baseURL = API_BASE_URL;

request.defaults.paramsSerializer = params =>
  queryString.stringify(params, {
    skipNull: true,
    skipEmptyString: true,
    arrayFormat: 'comma',
  });

if (import.meta.env.PROD) {
  setAppHeader(`account:${import.meta.env.GIT_REV}`, [
    PDA_ADMIN_V0_BASE_PATH,
    PDA_ADMIN_V1_BASE_PATH,
    REPORTS_API_BASE_PATH,
  ]);
}

export * from './apikeys';
export * from './customer-accounts';
export * from './my';
export * from './organizations';
export * from './planetary-variables';
export * from './plans-subscriptions';
export * from './products';
export * from './reports';
export * from './tasking';
export * from './users';
export * from './sentinel-hub';
